// extracted by mini-css-extract-plugin
export default {"collapsible-panel":"CollapsiblePanel_collapsible-panel__XGGj1","trigger":"CollapsiblePanel_trigger__Ik7xp","opened":"CollapsiblePanel_opened__fWO8G"};